// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"page-content_headerWrapper__Zv5Pa","contentWrapper":"page-content_contentWrapper__25Ima","content":"page-content_content__5n16c"};